import React, { useEffect } from "react";
import Loader from "../../../../components/shared/loader/Loader";
import { useDispatch, useSelector } from "react-redux";
import { getDevicesRequest } from "../../../../store/brotherPlus/getDevices/getDevicesSlice";
import { getLocalSessionData } from "../../../../utils/Authentication/handleUserSession";
import { 
    LOCALSESSIONDATAKEYS, 
    NATIVE_APP_SUBSCRIPTION_ATTRIBUTE, 
    USER_ENROLLED_SERVICE_LIST 
} from "../../../../constants/AppConstants";
import { 
    buildDirectServicePageQSNativeApp,
    buildOneBenefitPageQSNAtiveApp, 
    findValueByKey_From_ArrayOfObj, 
    getNativeAppQueryParamsValuesByKey, 
    isEcoproOrBplusDirectServicePage, 
    updateNativeAppQueryParams_LocalStorage
} from "../../../../constants/AppMethod";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { nativeAppRoutePaths } from "../../../../constants/Routes";

const BplusEnrollmentCheck = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const userId = getLocalSessionData(LOCALSESSIONDATAKEYS.UID);
    const serialNumber = getNativeAppQueryParamsValuesByKey("device_serial_no");
    const getDevicesResponse = useSelector((state => state.BROTHERPLUS.getDevices));

    useEffect(() => {   
        dispatch(getDevicesRequest({userId}));
        // eslint-disable-next-line
    }, [dispatch]);

     useEffect(() => { 
        if(getDevicesResponse?.error || getDevicesResponse?.success){
            const devicesArr = getDevicesResponse?.devices?.devices;
            let isBplusService = null;
            const isDeviceAvailable = findValueByKey_From_ArrayOfObj(devicesArr, 'serialNumber', serialNumber, 'serialNumber');

            if(isDeviceAvailable){
                const obtainServiceStatusObj = findValueByKey_From_ArrayOfObj(devicesArr, 'serialNumber', serialNumber, 'serviceStatus');
                isBplusService = findValueByKey_From_ArrayOfObj(obtainServiceStatusObj, 'serviceName', USER_ENROLLED_SERVICE_LIST.BPLUS, 'serviceName');
            }

            const enrollmentStatus = (isDeviceAvailable && isBplusService === USER_ENROLLED_SERVICE_LIST.BPLUS) ? NATIVE_APP_SUBSCRIPTION_ATTRIBUTE.ALREADY_ENROLLED : NATIVE_APP_SUBSCRIPTION_ATTRIBUTE.TO_BE_ENROLLED;

            const QS = (isEcoproOrBplusDirectServicePage()) ? buildDirectServicePageQSNativeApp(enrollmentStatus) : buildOneBenefitPageQSNAtiveApp(NATIVE_APP_SUBSCRIPTION_ATTRIBUTE.SKIP, enrollmentStatus);

            updateNativeAppQueryParams_LocalStorage(null, QS, LOCALSESSIONDATAKEYS.NATIVE_APP_AUTH_TOKEN_INFO);

            history.push(nativeAppRoutePaths.WEB_TO_APP_REDIRECTION);
        }
        // eslint-disable-next-line
    }, [getDevicesResponse?.success, getDevicesResponse?.error]);

    
    return (
        <Loader />
    )
}

export default BplusEnrollmentCheck;